// extracted by mini-css-extract-plugin
export default {"icon":"Jrr7mMgTqqMvd7lP6rzT","root":"uZIMChc4Q6umSOqnbxRv","open":"PitAv3y6QAYOBLAJZZ2e","small":"f_laDNjDT7DCp9x2CxXS"};